<template>
    <div class="brt-upload-module" :size="size">
        <div class="brt-um-upload">
            <Upload
                :show-upload-list="false"
                :action="action"
                :format="format"
                :max-size="maxSize"
                :on-exceeded-size="onMaxSize"
                :before-upload="before"
                :data="extraData"
                :on-error="onError"
                :name="name"
                :with-credentials="true"
                :on-success="success">
                <span class="brt-um-image" v-if="imageURL">
                    <img :src="imageURL" alt="">
                </span>
                <span class="brt-um-text" v-else>
                    <slot name="upload"></slot>
                </span>
            </Upload>
        </div>
        <div class="brt-um-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>

    import { Upload } from 'iview';

    export default {
        name: "UploadBox",

        data () {
            return {
                imageURL: this.value
            }
        },

        methods: {
            onMaxSize (file) {
                this.onExceededSize(file);
            },

            success (res, file) {
                this.imageURL = res.result;
                this.$emit('input', res.result);

                this.onSuccess(res, file);
            },
            before (file){
                return this.beforeUpload(file);
            },

            onError (error,file,fileList){
                this.uploadOnError(error,file,fileList)
            }
        },

        watch: {
            value (val) {

                if(this.imageURL === val) return;

                this.imageURL = val;
            }
        },


        props: {
            value: {
                default: ''
            },
            size: {
                default: ''
            },
            action: {
                default: ''
            },
            extraData:{

            },
            name:{

            },
            format: {
                type: Array
            },
            maxSize: {
                type: Number
            },
            onExceededSize: {
                type: Function,
                default: () => {}
            },
            onSuccess: {
                type: Function,
                default: () => {}
            },
            beforeUpload: {
                type: Function,
                default: () => {}
            },
            uploadOnError:{
                type: Function,
                default: () => {}
            }
        },
        components: {
            Upload
        }
    }
</script>

<style lang="less">
    @import "../../styles/comm.less";

    @size       : 80px;
    @smallSize  : 50px;
    @largeSize  : 120px;

    .brt-upload-module {

        &:after {
            content: '';
            display: block;
            visibility: hidden;
            opacity: 0;
            height: 0;
            clear: both;
        }

        > .brt-um-upload {
            float: left;
            margin-right: 0;
            width: @size;
            height: @size;
            border-radius: 3px;
            border: 1px dashed @SubThemeColor;
            overflow: hidden;
            transition: all @AnimateSpeed;

            .ivu-upload {
                width: 100%;
                height: 100%;
                line-height: @size - 2;
                text-align: center;
                cursor: pointer;
                color: @SubThemeColor;
                font-size: 0;
            }

            &:hover {
                @hColor : fade(@SubThemeColor, 60%);
                border-color: @hColor;
            }

            .brt-um-text {
                font-size: @ThemeFontSize;
            }

            .brt-um-image {
                display: block;
                width: 100%;
                height: 100%;
                line-height: @size - 2;
                text-align: center;
                position: relative;
                font-size: 0;

                img {
                    max-width: @size - 6;
                    max-height: @size - 6;
                    vertical-align: middle;
                }

                &:after {
                    font-family: "brt-icon" !important;
                    font-style: normal;
                    content: '\e658';
                    font-size: 24px;
                    color: #EEEEEE;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background-color: fade(#000000, 50%);
                    opacity: 0;
                    visibility: hidden;
                    transition: opacity @AnimateSpeed;
                }

                &:hover:after {
                    opacity: 1;
                    visibility: visible;
                }

            }

        }

        > .brt-um-content {
            padding-left: @size + 10px;
        }

        &[size='small'] {
            > .brt-um-upload {
                width: @smallSize;
                height: @smallSize;

                .ivu-upload {
                    line-height: @smallSize - 2;
                }

                .brt-um-image {
                    line-height: @smallSize - 2;

                    img {
                        max-width: @smallSize - 2;
                        max-height: @smallSize - 2;
                    }

                    &:after {
                        font-size: 18px;
                    }
                }

            }

            > .brt-um-content {
                padding-left: @smallSize + 10px;
            }
        }

        &[size='large'] {
            > .brt-um-upload {
                width: @largeSize;
                height: @largeSize;

                .ivu-upload {
                    line-height: @largeSize - 2;
                }

                .brt-um-image {
                    line-height: @largeSize - 2;

                    img {
                        max-width: @largeSize - 8;
                        max-height: @largeSize - 8;
                    }

                    &:after {
                        font-size: 30px;
                    }
                }
            }

            > .brt-um-content {
                padding-left: @largeSize + 10px;
            }
        }

    }
</style>
